
//Tricomply (US), Copyright © Temenos USA Inc. 2016-2019. All rights reserved.


/* eslint-disable angular/window-service */
//window.FullCalendar = require('@fullcalendar/core');
//window.dayGrid = require('@fullcalendar/daygrid');
window.$ = window.jQuery = require('jquery');
window.Tether = require('tether');
window.Bloodhound = require('typeahead.js-browserify').Bloodhound;
window.typeahead = require('typeahead.js-browserify');
window.moment = require('moment-timezone');
window.bsCustomFileInput = require('bs-custom-file-input');
window.Raphael = require('raphael');
/* eslint-enable angular/window-service */

typeahead.loadjQueryPlugin();

require('angular');
require('angular-mocks');
require('angular-animate');
require('angular-flash-alert');
require('tether');
require('popper.js');
require('bootstrap');
require('angular-trix');
require('checklist-model');
require('ng-file-upload');
require('angular-truncate-2');
require('../node_modules/jasny-bootstrap/dist/js/jasny-bootstrap.min.js');
require('angular-avatar');
require('angular-datepicker');
require('angular-utils-pagination');
require('angularjs-datepicker');
require('ng-stickyfill');
require('../node_modules/angular-filter/dist/angular-filter.js');
require('angular-moment');
require('../node_modules/morris.js/morris.min.js');

require('./core');
require('./app.module.js');
require('./app.config.js');
require('./app.route.js');
require('./constants.js');

require('./compliance_framework');
require('./compliance_services');
require('./compliance_forums');
require('./social_media_compliance');
require('./trid_calculator');
require('./vms');
